import React from "react";
import data from "../data.json";
import CardLayoutHOC from "../../../common/CardLayout/CardLayoutHOC";
import style from "./profile.scss";

const work_dt = data.WORK_EXPERIENCE;
const technology_dt = data.SKILLS.TECHNOLOGY;
const relatedCourses_dt = data.RELATED_COURSES;
const about_dt = data.ABOUT;

const experience = () => {
  return (
    <>
      {work_dt.map((data, key) => {
        return (
          <div key={key} className={style["card"]}>
            <div className={style["experience"]}>
              <div className={style["comp-dur"]}>
                <div className={style["name"]}>{data["Company Name"]}</div>
                <div className={style["duration"]}>{data["Duration"]}</div>
              </div>
              <div className={style["designation"]}>{data["Designation"]}</div>
              <div className={style["card-body"]}>{data["Description"]}</div>
            </div>
          </div>
        );
      })}
    </>
  );
};
export const Experience = CardLayoutHOC(
  experience,
  "EXPERIENCE",
  "work-experience-main"
);

const techno = () => {
  return (
    <>
      {Object.entries(technology_dt).map(([key, data]) => {
        return (
          <div key={key} className={style["card"]}>
            <div className={style["technology"]}>
              <div className={style["name"]}>{key}</div>
              <div className={style["card-body"]}>{data}</div>
            </div>
          </div>
        );
      })}
    </>
  );
};
export const Technology = CardLayoutHOC(
  techno,
  "TECHNOLOGY",
  "technology-main"
);

const relatedCourses = () => {
  return (
    <>
      {Object.entries(relatedCourses_dt).map(([key, data]) => {
        return (
          <div key={key} className={style["card"]}>
            <div className={style["course"]}>
              <div className={style["name"]}>{key}</div>
              <div className={style["card-body"]}>{data}</div>
            </div>
          </div>
        );
      })}
    </>
  );
};
export const RelatedCourses = CardLayoutHOC(
  relatedCourses,
  "RELATED COURSES",
  "realted_course-main"
);

const about = () => {
  return (
    <div className={style["card"]}>
      <div className={style["about"]}>{about_dt}</div>
    </div>
  );
};
export const About = CardLayoutHOC(about, "About", "about-main");
